// extracted by mini-css-extract-plugin
export default {"select":"Select_select__gahxC","select__dropdown":"Select_select__dropdown__AzlMQ"};